import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Row, Col, Form, Input, Button, Checkbox } from "antd";
import LeftContent from "./leftContent";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import logoText from "@assets/images/logo/dark-logo-text-nobg.png";
import { sumoSelectSignupAction } from "@redux/actions/authActions";
import { ErrorNotification } from "@components";
import { validateAppSumoSelectUser } from "@api/user/appsumo";
import { fireConfetti } from "@utils/confetti";

const initialFormData = {
  name: "",
  email: "",
  password: "",
  plan_id: "",
};

const AppSumoSelect = () => {
  const { email } = useParams();
  const dispatch = useDispatch();
  const [formData, setFormData] = useState(initialFormData);
  const [agree, setAgree] = useState(false);
  const [loading, setLoading] = useState(false);
  const [validSelectUser, setValidSelectUser] = useState(false);

  useEffect(() => {
    if (email) {
      validateAppSumoSelectUser(email)
        .then((res) => {
          setFormData({ ...formData, email });
          if (res.data.isValid === true) {
            setValidSelectUser(true);

            // Set plan_id and email
            setFormData({ ...formData, plan_id: res.data.plan_id, email });

            fireConfetti();
          } else {
            setValidSelectUser(false);
            ErrorNotification(
              "AppSumo Select Email is not a valid, please contact us for more info"
            );
          }
        })
        .catch((err) => {
          ErrorNotification(
            "AppSumo Select Email is not valid, please contact us for more info"
          );
        });
    }
  }, [email]);

  // Handle form change
  const handleFormChange = (e) => {
    e.preventDefault();
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle email sign up
  const handleEmailSignup = (e) => {
    e.preventDefault();

    const { name, email, password, plan_id } = formData;

    // Check if all fields are filled
    if (name === "" || email === "" || password === "") {
      ErrorNotification("Please enter all fields");
      return;
    }

    // Password length should not be more than 40 characters
    if (password.length > 40) {
      ErrorNotification("Password should not be more than 40 characters");
      return;
    }

    // If not agreed, show error
    if (!agree) {
      ErrorNotification("You need to agree to the terms and conditions");
      return;
    }

    try {
      // Dispatch email, password, org to action
      dispatch(
        sumoSelectSignupAction({
          name,
          email,
          password,
          plan_id,
          setFormData,
          initialFormData,
          setAgree,
          setLoading,
        })
      );
    } catch (error) {
      console.log("APPSUMO_SELECT_SIGNUP_ERROR", error);
    }
  };

  return (
    <>
      <Row
        gutter={[32, 0]}
        className="hp-authentication-page"
        style={{ overflowY: "auto", height: "100vh" }}
      >
        <LeftContent />

        <Col
          lg={8}
          md={16}
          sm={16}
          span={24}
          className="hp-py-sm-0 hp-py-md-0"
          justify="center"
        >
          <Row className="hp-h-100" align="middle" justify="center">
            <Col
              xxl={11}
              xl={15}
              lg={20}
              md={16}
              sm={24}
              className="hp-px-sm-8 hp-pt-24 hp-pb-48"
            >
              <img
                src={logoText}
                alt="logo"
                style={{
                  maxWidth: "200px",
                  height: "auto",
                  display: "block",
                  margin: "0 auto",
                }}
              />
              <h2
                className="hp-mb-sm-0"
                style={{
                  textAlign: "center",
                  fontSize: "24px",
                  lineHeight: "32px",
                  color: "rgba(0, 0, 0, 0.85)",
                }}
              >
                Create Account
              </h2>

              <Form
                layout="vertical"
                name="basic"
                className="hp-mt-sm-16 hp-mt-32"
              >
                <Form.Item label="Name :" className="hp-mb-16">
                  <Input
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleFormChange}
                  />
                </Form.Item>

                <Form.Item label="Email :">
                  <Input
                    id="email"
                    name="email"
                    value={formData.email}
                    disabled={email ? true : false}
                    style={{
                      cursor: email ? "not-allowed" : "auto",
                      color: email ? "#797979" : "#000",
                    }}
                  />
                </Form.Item>

                <Form.Item label="Password :">
                  <Input.Password
                    id="password"
                    name="password"
                    value={formData.password}
                    onChange={handleFormChange}
                  />
                </Form.Item>

                {/* Check box agreeing to terms and privacy */}
                <Form.Item>
                  <Row>
                    <Col span={24}>
                      <Checkbox
                        checked={agree}
                        onChange={() => setAgree(!agree)}
                      >
                        I agree to the{" "}
                        <Link
                          to="/terms"
                          className="hp-text-color-blue-100 hp-text-color-dark-80"
                        >
                          Term of use
                        </Link>
                        ,{" "}
                        <Link
                          to="/privacy"
                          className="hp-text-color-blue-100 hp-text-color-dark-80"
                        >
                          Privacy policy
                        </Link>{" "}
                        &{" "}
                        <Link
                          to="/ethics"
                          className="hp-text-color-blue-100 hp-text-color-dark-80"
                        >
                          Ethics
                        </Link>
                      </Checkbox>
                    </Col>
                  </Row>
                </Form.Item>

                <Form.Item className="hp-mt-16">
                  <Button
                    block
                    type="primary"
                    htmlType="submit"
                    onClick={handleEmailSignup}
                    loading={loading}
                    disabled={!validSelectUser}
                  >
                    Sign up
                  </Button>
                </Form.Item>
              </Form>

              <div className="login-create-acc">
                <p>Already have an account?</p>

                <Link to="/login"> Login</Link>
              </div>

              <Col
                className="hp-other-links hp-mt-24"
                style={{
                  justifyContent: "center",
                  display: "flex",
                }}
              >
                <Link
                  to="/privacy"
                  className="hp-text-color-black-80 hp-text-color-dark-40"
                  style={{
                    marginRight: "8px",
                  }}
                >
                  Privacy Policy
                </Link>

                {/* A dot in between */}
                <span
                  className="hp-text-color-black-80 hp-text-color-dark-40"
                  style={{ margin: "0 8px", fontSize: "12px" }}
                >
                  .
                </span>

                <Link
                  to="/terms"
                  className="hp-text-color-black-80 hp-text-color-dark-40"
                >
                  Terms of Service
                </Link>
              </Col>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default AppSumoSelect;
